import Box from "@material-ui/core/esm/Box";
import Typography from "@material-ui/core/esm/Typography";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import BadgeStep from 'components/BadgeStep/BadgeStep';
import SummaryPage from 'components/SummaryPage/SummaryPage';
import tagOptions from 'constants/tagOptions';
import useUnregisterVehicle from 'hooks/vehicles/unregister/useUnregisterVehicle';
import useStyles from './UnregisterVehicleSummaryStyles';
export default function UnregisterVehicleSummary() {
  const {
    t
  } = useTranslation();
  const {
    boldText
  } = useStyles();
  const {
    reset
  } = useUnregisterVehicle();
  const location = useLocation();
  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);
  if (location?.state?.tagOption === tagOptions.KEEP_AND_REUSE) {
    return /*#__PURE__*/React.createElement(SummaryPage, {
      header: t('unregister_vehicle.summary.inactivate.title')
    }, /*#__PURE__*/React.createElement(Box, {
      my: 4
    }, /*#__PURE__*/React.createElement(BadgeStep, {
      badgeContent: "1"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, /*#__PURE__*/React.createElement("span", {
      className: boldText
    }, t('unregister_vehicle.summary.inactivate.line1_bold')), "\xA0", /*#__PURE__*/React.createElement("span", null, t('unregister_vehicle.summary.inactivate.line1_regular'))))));
  }
  return /*#__PURE__*/React.createElement(SummaryPage, {
    header: t('unregister_vehicle.summary.terminate.title')
  }, /*#__PURE__*/React.createElement(Box, {
    my: 4
  }, /*#__PURE__*/React.createElement(BadgeStep, {
    badgeContent: "1"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, /*#__PURE__*/React.createElement("span", {
    className: boldText
  }, t('unregister_vehicle.summary.terminate.line1_bold')), "\xA0", /*#__PURE__*/React.createElement("span", null, t('unregister_vehicle.summary.terminate.line1_regular')))), /*#__PURE__*/React.createElement(BadgeStep, {
    badgeContent: "2"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, /*#__PURE__*/React.createElement("span", {
    className: boldText
  }, t('unregister_vehicle.summary.terminate.line2_bold')), "\xA0", /*#__PURE__*/React.createElement("span", null, t('unregister_vehicle.summary.terminate.line2_regular'))))));
}